import { useRefScrollHeight } from "./height"
import { LayoutFunction } from "./layout"

interface Props {

    layout: LayoutFunction

    text: string
    close(): void
    content: React.FunctionComponent<any>

}

export function Popup2(props: Props) {

    const { layout, text, close, content: Content } = props

    const ref = React.useRef<HTMLDivElement>(null)

    const dimensions = useRefScrollHeight(ref)

    const { top, left, bottom, right, maxHeight } = layout(dimensions)

    const style: React.CSSProperties = { minHeight: 0, display: "flex", flexDirection: "column", visibility: dimensions ? "visible" : "hidden" }

    return <div style={{ position: "absolute", top, left, bottom, right, maxHeight, overflow: "hidden", display: "flex", flexDirection: "column", justifyContent: "center", zIndex: 2000 }}>

        <div ref={ref} className="omnia-typeahead-popup" style={style}>
            <Content text={text} close={close} />
        </div>

    </div>
}
